<!-- Step 3: add/remove celebrants -->
<script>
    import {onMount} from 'svelte';
    import { fade } from 'svelte/transition';
    import isLoading from '../stores/loading-store';
    import {reservation, steps} from '../stores/reservation-store';
    import FormNavigation from './event-form-navigation.svelte';
    import CelebrantForm from './celebrant.svelte';
    import RecapTable from './recap-table.svelte';

    import {
        i18n,
    } from "svelte-translate";

    const urlParams = new URLSearchParams(window.location.search);

    function isPositiveInteger(n) {
        return n >>> 0 === parseFloat(n);
    }

    onMount(async () => {
        isLoading.set(true);
        if ($reservation.eventType === "KOparty-Birthday" || $reservation.eventType === "KOmini-Birthday") {
            $steps.previousStep = 1;
        } else {
            $steps.previousStep = 2;
        }
        $steps.nextStep = 4;
        isLoading.set(false);

        let f = function() {
            this.classList.add('touched')
        }
        document.querySelectorAll('input')
                .forEach((e) => {
                    e.addEventListener('blur', f, false)
                    e.addEventListener('keydown', f, false)
                })
        validateForm();
    });

    const addCelebrant = () => {
        $reservation.celebrantIndex += 1;
        let newCelebrant = {'id': $reservation.celebrantIndex, 'name': '', 'age': null, 'gender': null};
        $reservation.celebrants = [...$reservation.celebrants, newCelebrant];
    }

    const validateForm = () => {
        // uses HTML5 native validation, should be extended/improved.
        $steps.nextStepAllowed = !!document.getElementById("celebrants-form").checkValidity();
    };

    const removal = () => {
        setTimeout(validateForm, 500);
    }

</script>

<div out:fade="{{delay: 0, duration: 150 }}" in:fade="{{delay: 500, duration: 200 }}" class="pb-4">
    <form id="celebrants-form" class="Form-container"
          on:invalid={validateForm}
          on:changed={validateForm}
          on:input={validateForm}>

        <div class="Form-split">
            <RecapTable />
        </div>
        <div class="Form-split">

           {#each $reservation.celebrants as celebrant}
           <CelebrantForm {celebrant} on:celebrantRemoved="{removal}" />
           {/each}
            <div class="Celebrant-add">
                <button type="button" class="button" on:click|preventDefault={addCelebrant} use:i18n={"addCelebrantButtonLabel"}>Add another</button>
            </div>
        </div>
    </form>
    <FormNavigation />
</div>

